<template>
  <div v-loading.fullscreen.lock="loading">
    <div class="piece_order">
      <div class="piece_order_left">
        <div class="piece_order_left_card">
          <div class="piece_order_title piece_order_title_btn">
            <div>托运人信息</div>
            <el-button type="primary" @click="startAddressVisible = true"
              >从地址薄中选择</el-button
            >
          </div>
          <div class="piece_order_left_card_form">
            <el-row :gutter="20">
              <el-col :span="12">
                <div
                  class="piece_order_input"
                  @click="startAddressVisible = true"
                >
                  <span
                    class="piece_order_input_value"
                    v-if="startAddress.contacts_name"
                    >{{ startAddress.contacts_name }}</span
                  >
                  <span class="piece_order_input_placeholder" v-else
                    >请填写托运人姓名或公司名称</span
                  >
                </div>
              </el-col>
              <el-col :span="12">
                <div
                  class="piece_order_input"
                  @click="startAddressVisible = true"
                >
                  <span
                    class="piece_order_input_value"
                    v-if="startAddress.contacts_phone"
                    >{{ startAddress.contacts_phone }}</span
                  >
                  <span class="piece_order_input_placeholder" v-else
                    >请填写托运人手机号码</span
                  >
                </div>
                <!-- <el-input v-model="form.name" placeholder="请填写托运人手机号码"></el-input> -->
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <div
                  class="piece_order_input"
                  @click="startAddressVisible = true"
                >
                  <span
                    class="piece_order_input_value"
                    v-if="startAddress.detalied_address"
                    >{{ startAddress.detalied_address }}</span
                  >
                  <span class="piece_order_input_placeholder" v-else
                    >请填写详细地址</span
                  >
                </div>
                <!-- <el-input v-model="startAddressData.address" placeholder="请填写详细地址"></el-input> -->
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="piece_order_left_card" style="margin-top: 24px">
          <div class="piece_order_title piece_order_title_btn">
            <div>收件人信息</div>
            <el-button type="primary" @click="endAddressVisible = true"
              >从地址薄中选择</el-button
            >
          </div>
          <div class="piece_order_left_card_form">
            <el-row :gutter="20">
              <el-col :span="12">
                <div
                  class="piece_order_input"
                  @click="endAddressVisible = true"
                >
                  <span
                    class="piece_order_input_value"
                    v-if="endAddress.province"
                    >{{ endAddress.province }}{{ endAddress.city
                    }}{{ endAddress.district }}</span
                  >
                  <span class="piece_order_input_placeholder" v-else
                    >请选择收件人的城市</span
                  >
                </div>
                <!-- <mapSelectAddress :disabled="true" :placeholder="'请选择收件人的城市'" @selectMap="selectEndMap"></mapSelectAddress> -->
              </el-col>
              <el-col :span="12">
                <div
                  class="piece_order_input"
                  @click="endAddressVisible = true"
                >
                  <span
                    class="piece_order_input_value"
                    v-if="endAddress.owner_name"
                    >{{ endAddress.owner_name }}</span
                  >
                  <span class="piece_order_input_placeholder" v-else
                    >请填写公司名称（选填）</span
                  >
                </div>
                <!-- <el-input v-model="form.name" placeholder="请填写公司名称（选填）"></el-input> -->
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <!-- <el-input v-model="endAddressData.address" placeholder="请填写详细地址"></el-input> -->
                <div
                  class="piece_order_input"
                  @click="endAddressVisible = true"
                >
                  <span
                    class="piece_order_input_value"
                    v-if="endAddress.detalied_address"
                    >{{ endAddress.detalied_address }}</span
                  >
                  <span class="piece_order_input_placeholder" v-else
                    >请填写详细地址</span
                  >
                </div>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="piece_order_left_card" style="margin-top: 24px">
          <div class="piece_order_title piece_order_title_btn">
            <div>专线信息</div>
            <div>{{ junxina.zname }}</div>
            <el-button type="primary" @click="opneDi()" style="width: 140px"
              >选择专线</el-button
            >
          </div>
          <!-- <div v-show="junxina.id">
                      <gaodeMap ref="mapRef"></gaodeMap>
                    </div> -->
          <!-- <div v-show="junxina.id" class="piece_order_left_card_form" style="padding: 20px 0;">

                               <div style="font-size: 20px;border-bottom: 1px solid #cbcbcb;text-align: center;padding-bottom: 10px;">
                                   <span>{{junxina.setcity}}</span>
                                   <span><i style="transform: rotate(90deg)" class="el-icon-sort"></i></span>
                                   <span>{{junxina.arrcity}}</span>
                                 </div>
                                 <div style="padding: 20px;padding-bottom: 0px;">
                                        <div style="font-size: 16px;font-weight: 700;margin-bottom: 20px;color: #303133;">专线信息</div>
                                         <div>
                                           <el-table border style="width: 100%"  :data="tableData" >
                                             <el-table-column label="承运公司 ">
                                                  <template slot-scope="scope"><span>{{junxina.zname}}</span></template>
                                               </el-table-column>
                                               <el-table-column label="运输车型">
                                                  <template slot-scope="scope"><span>{{junxina.cartype}}</span></template>
                                               </el-table-column>
                                               <el-table-column label="联系人">
                                                  <template slot-scope="scope"><span>{{junxina.setname}}</span></template>
                                               </el-table-column>
                                                <el-table-column label="虚拟电话">
                                                  <template slot-scope="scope"><span>{{junxina.fictitious_arrphone}}</span></template>
                                               </el-table-column>
                                               <el-table-column label="出发地址">
                                                  <template slot-scope="scope"><span>{{junxina.setaddress}} </span></template>
                                               </el-table-column>
                                               <el-table-column label="到站地址 ">
                                                  <template slot-scope="scope"><span>{{junxina.arraddress}}</span></template>
                                               </el-table-column>
                                             </el-table>
                                             </el-table>
                                         </div>

                           </div>
                    </div> -->
        </div>

        <div
          class="piece_order_left_card"
          style="margin-top: 24px; min-height: 200px"
        >
          <!--  <div class="piece_order_title">
                            <div>托运信息</div>
                        </div> -->
          <div class="piece_order_left_card_form" style="padding-bottom: 6px">
            <el-form class="tableBody" label-width="90px" label-position="left">
              <el-form-item
                label="增值服务"
                style="margin-top: 20px; padding-top: 10px"
              >
                <!-- <el-checkbox-group v-model="form.added_service" @change="getDebouncePrice" class="piece_order_left_card_form_checkbox">
                                        <el-checkbox v-for="item in servicesTypeList" :label="item.id" :key="item.id" @change="servicesTypeRadio">{{item.name}}</el-checkbox>
                                    </el-checkbox-group>
                                    <el-input v-if="isDs"  oninput="value=value.replace(/[^\d.]/g,'')" @change="getDebouncePrice" v-model="ds_fee" placeholder="请输入代收货费用"></el-input>
                                    <el-input style="margin-top: 10px;" v-if="isQt"  oninput="value=value.replace(/[^\d.]/g,'')" @change="getDebouncePrice" v-model="qt_fee" placeholder="请输入其它费用"></el-input>
                                    <el-input style="margin-top: 10px;" v-if="isSh"  oninput="value=value.replace(/[^\d.]/g,'')" @change="getDebouncePrice" v-model="sh_fee" placeholder="请输入送货费用"></el-input>
                                    <el-input style="margin-top: 10px;" v-if="isTh"  oninput="value=value.replace(/[^\d.]/g,'')" @change="getDebouncePrice" v-model="th_fee" placeholder="请输入提货费费用"></el-input> -->

                <el-checkbox-group
                  v-model="form.added_service"
                  @change="getDebouncePrice"
                >
                  <el-table
                    style="padding: 19px 0"
                    ref="multipleTable"
                    :show-header="headerStatus"
                    :data="servicesTypeList"
                  >
                    <el-table-column style="padding: 5px 0 !important">
                      <template slot-scope="scope">
                        <el-checkbox
                          @change="servicesTypeRadio"
                          :label="scope.row.id"
                          >{{ scope.row.name }}</el-checkbox
                        >
                      </template>
                    </el-table-column>
                    <el-table-column style="padding: 5px 0 !important">
                      <template slot-scope="scope">
                        <el-input
                          style="width: 70px;"
                          v-if="
                            isDs &&
                            (scope.row.name == '代收货款费' ||
                              scope.row.name == '代收货款')
                          "
                          oninput="value=value.replace(/[^\d.]/g,'')"
                          @change="getDebouncePrice"
                          v-model="ds_fee"
                        >
                        <template slot="append">元</template>
                        </el-input>
                        <!-- placeholder="请输入代收货费用" -->
                        <el-input
                          style="width: 70px"
                          v-if="
                            isQt &&
                            (scope.row.name == '其他费用' ||
                              scope.row.name == '其他费'||
                              scope.row.name == '其它费用'||
                              scope.row.name == '其它费')
                          "
                          oninput="value=value.replace(/[^\d.]/g,'')"
                          @change="getDebouncePrice"
                          v-model="qt_fee"
                        >
                        <template slot="append">元</template>
                        </el-input>
                        <el-input
                          style="width: 70px; margin-left: 18px"
                          v-if="
                            isSh &&
                            (scope.row.name == '送货费用' ||
                              scope.row.name == '送货费')
                          "
                          oninput="value=value.replace(/[^\d.]/g,'')"
                          @change="getDebouncePrice"
                          v-model="sh_fee"
                        >
                        <template slot="append">元</template>
                        </el-input>
                        <el-input
                          style="width: 70px"
                          v-if="
                            isTh &&
                            (scope.row.name == '提货费用' ||
                              scope.row.name == '提货费')
                          "
                          oninput="value=value.replace(/[^\d.]/g,'')"
                          @change="getDebouncePrice"
                          v-model="th_fee"
                        >
                        <template slot="append">元</template>
                        </el-input>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-checkbox-group>
              </el-form-item>
              <!-- <el-form-item label="物流方式" style="margin-top:20px">
                                    <el-radio-group v-model="form.logistics_type" @change="getDebouncePrice" class="piece_order_left_card_form_checkbox">
                                        <el-radio v-for="item in typeList" :label="item.id" :key="item.id">{{item.value}}</el-radio>
                                    </el-radio-group>
                                </el-form-item> -->
            </el-form>
          </div>
        </div>
      </div>
      <div class="piece_order_right">
        <div class="piece_order_right_card" style="min-height: 794px">
          <div class="piece_order_title">
            <div>物品信息</div>
          </div>
          <div class="piece_order_right_card_form" style="padding-bottom: 6px">
            <el-form label-width="180px" label-position="left">
              <el-form-item label="物品类型" style="margin-top: 20px">
                <el-radio-group
                  v-model="form.goods_type"
                  @change="getDebouncePrice"
                  class="piece_order_left_card_form_checkbox"
                >
                  <el-radio
                    v-for="item in goodsTypeList"
                    :label="item.id"
                    :key="item.id"
                    @change="goodsRadio"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
                <el-input
                  v-if="isGoodsTypeCustom"
                  v-model="form.goods_type_other"
                  placeholder="请输入其他物品类型"
                ></el-input>
              </el-form-item>
              <el-form-item label="包装类型" style="margin-top: 20px">
                <el-checkbox-group
                  v-model="form.pack_type"
                  @change="getDebouncePrice"
                  class="piece_order_left_card_form_checkbox"
                >
                  <el-checkbox
                    v-for="item in packTypeList"
                    :label="item.id"
                    :key="item.id"
                    @change="packTypeRadio"
                    >{{ item.name }}</el-checkbox
                  >
                </el-checkbox-group>
                <el-input
                  v-if="isPackTypeCustom"
                  v-model="form.pack_type_other"
                  placeholder="请输入其他包装类型"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="数量"
                style="margin-top: 20px"
                class="piece_order_right_card_form_num"
              >
                <div style="position: relative; padding-left: 180px">
                  <el-input-number
                    v-model="form.goods_num"
                    @change="getDebouncePrice"
                    :min="1"
                    :max="9999"
                  ></el-input-number>
                  <div class="piece_order_right_card_form_num_unit">件</div>
                </div>
              </el-form-item>
              <el-form-item label="重量" style="margin-top: 20px">
                <div
                  style="position: relative; padding-left: 180px"
                  class="piece_order_right_card_form_num"
                >
                  <el-input-number
                    v-model="form.goods_weight"
                    @change="getDebouncePrice"
                    :min="1"
                    :max="99999"
                  ></el-input-number>
                  <div class="piece_order_right_card_form_num_unit">吨</div>
                </div>
              </el-form-item>
              <el-form-item
                label="体积"
                style="margin-top: 20px"
                class="piece_order_right_card_form_num"
              >
                <div style="position: relative; padding-left: 180px">
                  <el-input-number
                    v-model="form.goods_volume"
                    @change="getDebouncePrice"
                    :min="1"
                    :max="99999"
                  ></el-input-number>
                  <div
                    class="
                      piece_order_right_card_form_num_unit
                      piece_order_right_card_form_num_lifang
                    "
                  >
                    m³
                  </div>
                </div>
              </el-form-item>
              <!--   <div class="piece_order_right_card_form_title">物品照片与备注（非必填）</div> -->
              <div class="piece_order_right_card_form_imgList">
                <div
                  class="piece_order_right_card_form_imgList_item"
                  v-if="form.goods_image.length < 3"
                >
                  <uploadImage :img="img" @imgUpload="imgUpload"></uploadImage>
                </div>
                <div
                  class="piece_order_right_card_form_imgList_img"
                  @mouseover="selectIconIndex = index"
                  @mouseleave="selectIconIndex = -1"
                  v-for="(imgItem, index) in form.goods_image"
                  :key="index"
                >
                  <img
                    style="cursor: pointer"
                    @click.stop="showImg(index)"
                    :src="$imgUrl + imgItem"
                    alt=""
                  />
                  <img
                    v-if="index != selectIconIndex"
                    class="piece_order_right_card_form_imgList_img_icon1"
                    src="../../assets/img_done.png"
                    alt=""
                  />
                  <img
                    v-else
                    class="piece_order_right_card_form_imgList_img_icon1"
                    @click="deleteImg(index)"
                    src="../../assets/img_delete.png"
                    alt=""
                  />
                </div>
              </div>
              <div style="margin-top: 16px; margin-bottom: 20px">
                <el-input
                  v-model="form.remark"
                  style="font-size: 18px"
                  type="textarea"
                  rows="3"
                  show-word-limit
                  maxlength="100"
                  resize="none"
                  placeholder="请填写备注信息"
                ></el-input>
              </div>
            </el-form>
          </div>
        </div>
        <div class="piece_order_right_card" style="margin-top: 24px">
          <!-- <div class="piece_order_title">
                            <div>结算类型</div>
                        </div> -->
          <div
            class="piece_order_left_card_form"
            style="padding-bottom: 6px; padding-top: 1px"
          >
            <el-form label-width="180px" label-position="left">
              <el-form-item style="margin-top: 20px">
                <span slot="label">
                  <span style="font-weight: 500">结算类型</span>
                </span>
                <el-radio-group
                  v-model="form.settlement_type"
                  class="piece_order_left_card_form_checkbox"
                >
                  <el-radio
                    v-for="item in settlementTypeList"
                    :label="item.id"
                    :key="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div class="piece_order_cost_card" style="margin-top: 20px">
      <div class="piece_order_title">
        <div>费用明细</div>
      </div>
      <div class="ckj1" style="border-bottom: 0px solid #d0d0d0">
        <el-row style="padding: 10px 0px">
          <el-col :span="6">
            <div class="grid-content">
              <!-- <span style="font-weight: 550">参考价</span> -->
              <span
                class="piece_order_cost_card_list_item_title"
                style="font-weight: 550"
                >参考价</span
              >
              <span v-if="priceData.base_price"
                >¥{{ priceData.base_price }}</span
              >
              &nbsp;
            </div>
          </el-col>
          <el-col :span="7">
            <div class="grid-content">
              <span
                class="piece_order_cost_card_list_item_title"
                style="font-weight: 550"
                >电议价</span
              >
              <el-input
                oninput="value=value.replace(/[^\d.]/g,'')"
                v-model="priceData.rebate_price"
                @input="getDebouncePrice"
                style="
                  width: 100px;
                  font-size: 20px;
                  border-bottom: 1px solid #000;
                "
              ></el-input>
              <span
                class="piece_order_cost_card_list_item_title"
                style="font-weight: 550"
                >元</span
              >
            </div>
          </el-col>
          <el-col :span="8">
            <span
              class="piece_order_cost_card_list_item_title"
              style="font-weight: 550"
              >物品价值</span
            >
            <el-input
              v-model="priceData.goods_value"
              @input="getDebouncePrice"
              style="
                width: 100px;
                font-size: 20px;
                border-bottom: 1px solid #000;
              "
            ></el-input>
            <span
              class="piece_order_cost_card_list_item_title"
              style="font-weight: 550"
              >元</span
            >
          </el-col>
          <el-col :span="3">
            <div class="piece_order_cost_card_list_item_num">
              <span
                class="piece_order_cost_card_list_item_num_coupon"
                style="font-weight: 550"
                @click="selectCoupon"
                >选择优惠券</span
              >
              <span v-if="couponData.reduce">¥{{ couponData.reduce }}</span>
            </div>
          </el-col>
        </el-row>

        <el-row style="padding: 10px 0px">
          <el-col :span="6">
            <span
              class="piece_order_cost_card_list_item_title"
              style="font-weight: 550"
              >增值服务费</span
            >
            <span v-if="form.added_service_price"
              >¥{{ form.added_service_price }}</span
            >
          </el-col>
          <el-col :span="5">
            <span
              class="piece_order_cost_card_list_item_title"
              style="font-weight: 550"
              >保价</span
            >
            <span v-if="priceData.insured_price"
              >¥{{ priceData.insured_price }}</span
            >
          </el-col>

          <el-col :span="5">
              <span
                class="piece_order_cost_card_list_item_title"
                style="font-weight: 550"
                v-if="form.settlement_type==1"
                >佣金</span
              >
              <el-input
                v-model="form.custom_commission_price"
                @input="getDebouncePrice"
                v-if="form.settlement_type==1"
                style="
                  width: 100px;
                  font-size: 20px;
                  border-bottom: 1px solid #000;
                "
              ></el-input>
              <span
                class="piece_order_cost_card_list_item_title"
                style="font-weight: 550"
                v-if="form.settlement_type==1"
                >元</span
              >
            <p  v-if="form.settlement_type!=1">&nbsp;</p>
          </el-col>

          <el-col :span="4">
            <div
              class="piece_order_cost_card_list_item_title"
              style="font-weight: 550"
              v-if="priceData.total_price"
            >
              总计: ¥{{ priceData.total_price }}
            </div>
            <p v-else>&nbsp;</p>
          </el-col>
          <el-col :span="3">
            <div style="">
              <el-button type="primary" @click="submit">立即下单</el-button>
              <!-- <div v-if="priceData.total_price">
                总计: ¥{{ priceData.total_price }}
              </div> -->
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- <div class="ckj1" style="border-bottom: 0px solid #d0d0d0;">
                <el-row>
                  <el-col :span="3"><div style="font-weight: 500;">参考价</div></el-col>
                  <el-col :span="14"><div  class="grid-content">
                  <span class="piece_order_cost_card_list_item_title"></span>
                  <span  v-if="priceData.base_price">¥{{priceData.base_price}}</span> 
                  &nbsp;
                  </div></el-col>
                  <el-col :span="7" ><div  class="grid-content">
                     <span class="piece_order_cost_card_list_item_title">电议价</span>
                     <el-input  oninput="value=value.replace(/[^\d.]/g,'')" v-model="priceData.rebate_price" @input="getDebouncePrice" placeholder="请输入电议价" style="width: 200px; font-size: 20px;"></el-input>
                     <span class="piece_order_cost_card_list_item_title">元</span>
                  </div></el-col>
                </el-row>
            </div> -->
      <!-- <div class="piece_order_cost_card_list2">
                <div class="ckj1_ite1">
                    <div class="w_60">
                      <span class="piece_order_cost_card_list_item_title">物品价值</span>
                     <el-input v-model="priceData.goods_value" @input="getDebouncePrice"   style="width: 100px; font-size: 20px;border:1px solid #eee;"></el-input>
                     <span class="piece_order_cost_card_list_item_title">元</span>
                    </div>
                    <div class="w_40">
                      <span class="piece_order_cost_card_list_item_title">保价</span>
                      <span v-if="priceData.insured_price">¥{{priceData.insured_price}}</span>
                    </div>
                </div>

                <div class="ckj1_ite1">
                    <div class="w_60">
                     <span class="piece_order_cost_card_list_item_title">增值服务费</span>
                     <span v-if="form.added_service_price">¥{{form.added_service_price}}</span>
                    </div>
                    <div class="w_40 f_j_s">
                      <div class="piece_order_cost_card_list_item_title"> </div>
                      <div class="piece_order_cost_card_list_item_num">
                          <span class="piece_order_cost_card_list_item_num_coupon" @click="selectCoupon">选择优惠券</span>
                          <span v-if="couponData.reduce">¥{{couponData.reduce}}</span>
                      </div>
                    </div>
                </div>
                <div class="ckj1_ite1" v-if="form.settlement_type==1">
                    <div class="w_60">
                      <span class="piece_order_cost_card_list_item_title">佣金</span>
                     <el-input v-model="form.custom_commission_price" @input="getDebouncePrice" placeholder="请输入佣金" style="width: 400px;"></el-input>
                     <span class="piece_order_cost_card_list_item_title">元</span>
                    </div>

                </div>
            </div> -->

      <div class="piece_order_cost_card_total">
        <div class="piece_order_cost_card_total_settlement">
          <div></div>
          <!-- <div v-if="priceData.total_price">总计: ¥{{priceData.total_price}}</div> -->
        </div>
        <div class="piece_order_cost_card_total_btn">
          <!-- <el-button type="primary" @click="submit">立即下单</el-button> -->
        </div>
      </div>
    </div>

    <el-image-viewer
      v-if="showViewer"
      :on-close="
        () => {
          showViewer = false;
        }
      "
      :url-list="imgPreviewList"
    />
    <coupon
      v-if="couponVisible"
      :couponVisible.sync="couponVisible"
      :couponId="form.coupon_id"
      :couponCallback="couponCallback"
    ></coupon>
    <start-address
      v-if="startAddressVisible"
      :startAddressVisible.sync="startAddressVisible"
      :startCallback="startCallback"
    ></start-address>
    <dedicatedInformation
      ref="dIRefs"
      :startCallback="startCallbackIn"
    ></dedicatedInformation>
    <end-address
      v-if="endAddressVisible"
      :endAddressVisible.sync="endAddressVisible"
      :endCallback="endCallback"
    ></end-address>
    <order-success
      v-if="orderSuccessVisible"
      :orderSuccessVisible.sync="orderSuccessVisible"
    ></order-success>
  </div>
</template>

<script>
import mapSelectAddress from "../../components/mapSelectAddress";
import uploadImage from "../../components/uplaodImage";
import coupon from "./components/coupon";
import StartAddress from "./components/startAddress.vue";
import dedicatedInformation from "./components/dedicatedInformation.vue";
import EndAddress from "./components/endAddress.vue";
import gaodeMap from "./components/gaodeMap.vue";
import OrderSuccess from "./components/orderSuccess.vue";
import debounce from "lodash.debounce";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  data() {
    return {
      headerStatus: false,
      form: {
        added_service: [],
        goods_num: 1,
        delivery_type: 0,
        logistics_type: 1,
        goods_volume: 1,
        goods_weight: 1,
        goods_type: "",
        goods_value: 0,
        settlement_type: 0,
        goods_image: [],
        pack_type: [],
        coupon_id: "",
        goods_type_other: "",
        pack_type_other: "",
        services_type_custom: "",
        added_service_price: "",
        deline_id: 0,
        custom_commission_price: "",
      },
      loading: false,
      tableData: [{}],
      settlementTypeList: [
        { id: 0, name: "寄付现结" },
        { id: 1, name: "货到付款" },
        { id: 2, name: "月结" },
      ], //结算类型数组
      img: require("../../assets/upload.png"),
      mapVisible: false,
      optionsList: [],
      startAddressData: {
        lng: null,
        lat: null,
        city: "",
        address: "",
      },
      endAddressData: {
        lng: null,
        lat: null,
        city: "",
        address: "",
      },
      servicesTypeList: [],
      packTypeList: [],
      goodsTypeList: [],
      isGoodsTypeCustom: false,
      goodsTypeCustom: "",
      isPackTypeCustom: false,
      isServicesTypeCustom: false,
      typeList: [
        { id: 1, value: "专线物流" },
        { id: 2, value: "定日达" },
      ],
      junxina: {},
      serviceList: [
        {
          id: 4,
          weight: 1,
          name: "等通知放货",
          association_category: 1,
          price: "11.00",
        },
        {
          id: 5,
          weight: 1,
          name: "签回单",
          association_category: 1,
          price: "11.00",
        },
        {
          id: 6,
          weight: 1,
          name: "定日达",
          association_category: 1,
          price: "11.00",
        },
        {
          id: 7,
          weight: 1,
          name: "测试1113",
          association_category: 1,
          price: "11.00",
        },
        {
          id: 8,
          weight: 1,
          name: "测试1113",
          association_category: 1,
          price: "11.00",
        },
        {
          id: 9,
          weight: 1,
          name: "测试1113",
          association_category: 1,
          price: "11.00",
        },
        {
          id: 10,
          weight: 1,
          name: "测试1113",
          association_category: 1,
          price: "11.00",
        },
        {
          id: 11,
          weight: 1,
          name: "测试1113",
          association_category: 1,
          price: "11.00",
        },
      ],

      couponVisible: false,
      startAddress: {},
      endAddress: {},
      startAddressVisible: false,
      dedicatedInformationVisible: false,
      endAddressVisible: false,
      couponData: {},
      priceData: {},
      selectIconIndex: -1,
      orderSuccessVisible: false,

      imgPreviewList: [],
      showViewer: false,
      previewIndex: 0,
      isDs: false,
      isQt: false,
      isSh: false,
      isTh: false,
      ds_fee: "",
      qt_fee: "",
      sh_fee: "",
      th_fee: "",
    };
  },
  components: {
    mapSelectAddress,
    uploadImage,
    coupon,
    StartAddress,
    dedicatedInformation,
    EndAddress,
    gaodeMap,
    OrderSuccess,
    ElImageViewer,
  },
  watch: {},
  computed: {},
  methods: {
    //选 择专线回调
    startCallbackIn(time) {
      this.junxina = time;
      this.form.deline_id = time.id;
    },
    //物品类型
    goodsRadio(e) {
      var thas = this;
      thas.isGoodsTypeCustom = false;
      thas.goodsTypeList.map((itme) => {
        if (itme.id == e && itme.name == "其他") {
          thas.isGoodsTypeCustom = true;
        }
      });
    }, //增值服务
    servicesTypeRadio(e) {
      var thas = this;
      thas.isDs = false;
      thas.isQt = false;
      thas.isSh = false;
      thas.isTh = false;
      thas.servicesTypeList.map((itme) => {
        if (thas.form.added_service.indexOf(itme.id) != -1) {
          console.log(itme);
          if (itme.name == "提货费用" || itme.name == "提货费") {
            thas.isTh = true;
          } else if (itme.name == "送货费用" || itme.name == "送货费") {
            thas.isSh = true;
          } else if (itme.name == "代收货款费" || itme.name == "代收货款") {
            thas.isDs = true;
          } else if (itme.name == "其他费用" || itme.name == "其它费" || itme.name == "其他费" || itme.name == "其它费用") {
            thas.isQt = true;
          }
        }
      });

      if (thas.isDs == false) {
        thas.ds_fee = "";
      }
      if (thas.isQt == false) {
        thas.qt_fee = "";
      }
      if (thas.isSh == false) {
        thas.sh_fee = "";
      }
      if (thas.isTh == false) {
        thas.th_fee = "";
      }
      /* if( thas.isServicesTypeCustom==false){
            this.form.services_type_custom='';
       } */
    },

    //物品类型
    packTypeRadio(e) {
      /* console.log(this.form.pack_type) */
      var thas = this;
      thas.isPackTypeCustom = false;
      thas.packTypeList.map((itme) => {
        if (thas.form.pack_type.indexOf(itme.id) != -1 && itme.name == "其他") {
          thas.isPackTypeCustom = true;
        }
      });
    },
    set_map() {
      /*  if(this.startAddress.id>0 && this.endAddress.id>0){
            this.$refs.mapRef.open(this.startAddress,this.endAddress)
       } */
    },
    //选择专线
    opneDi() {
      if (!this.startAddress.id) {
        this.$message.error("请选择托运人信息！");
        return false;
      }
      if (!this.endAddress.id) {
        this.$message.error("请选择收件人信息！");
        return false;
      }
      this.$refs.dIRefs.open(this.startAddress, this.endAddress);
    },
    showImg(index) {
      let imgList = [];
      for (let i = 0; i < this.form.goods_image.length; i++) {
        if (index + i < this.form.goods_image.length) {
          imgList.push(this.$imgUrl + this.form.goods_image[index + i]);
        } else {
          imgList.push(this.$imgUrl + this.form.goods_image[i - index - 1]);
        }
      }
      this.imgPreviewList = imgList;
      this.previewIndex = index;
      this.showViewer = true;
    },
    // 物品照片删除
    deleteImg(index) {
      this.form.goods_image.splice(index, 1);
    },
    imgUpload(data) {
      this.form.goods_image.push(data.image_path);
    },
    submit() {
      this.loading = true;
      this.$post("CreateOrder", this.form).then(
        (data) => {
          this.$message.success("下单成功！");
          this.loading = false;
          this.orderSuccessVisible = true;
          // this.$router.push({path:'/orderList'});
        },
        (error) => {
          this.$message.error(error);
          this.loading = false;
        }
      );
    },
    handleChange() {},

    //选择优惠券
    selectCoupon() {
      this.couponVisible = true;
    },
    //    选择过优惠券的回调函数
    couponCallback(data) {
      this.form.coupon_id = data.id;
      this.couponData = data;
      this.getDebouncePrice();
      this.couponVisible = false;
    },
    //    选择托运地址后的反填
    startCallback(data) {
      console.log(data);
      this.startAddress = data;
      this.form.address_start_id = data.id;
      this.getDebouncePrice();
      this.startAddressVisible = false;
      this.set_map();
    },
    //    选择收货信息的反填
    endCallback(data) {
      console.log(data);
      this.endAddress = data;
      this.form.address_end_id = data.id;
      this.getDebouncePrice();
      this.endAddressVisible = false;
      this.set_map();
    },
    get_number(vara) {
      if (vara > 0) {
        return parseInt(vara);
      } else {
        return 0;
      }
    },
    getPrice() {
      // this.form.added_service_price =
      //   this.get_number(this.ds_fee) +
      //   this.get_number(this.qt_fee) +
      //   this.get_number(this.sh_fee) +
      //   this.get_number(this.th_fee);
      this.form.added_service_price =
        this.get_number(this.qt_fee) +
        this.get_number(this.sh_fee) +
        this.get_number(this.th_fee);
      console.log(parseInt(this.ds_fee), this.ds_fee);
      if (this.form.address_start_id && this.form.address_end_id) {
        this.form.rebate_price = this.priceData.rebate_price;
        this.form.goods_value = this.priceData.goods_value || 0;
        this.form.rebate_price = this.priceData.rebate_price || 0;
        // this.form.added_service_price = this.priceData.added_service_price || 0;
        this.$post("CalculationOrderPrice", this.form).then(
          (data) => {
            delete data.rebate_price;
            Object.assign(this.priceData, data);
            this.$forceUpdate();
          },
          (error) => {
            this.$message.error(error);
          }
        );
      }
    },
    getDebouncePrice: debounce(function () {
      this.getPrice();
    }, 100),
    // 发件人的地址选择
    selectStartMap(address) {
      this.startAddressData = address;
    },
    // 收件人的地址选择
    selectEndMap(address) {
      this.endAddressData = address;
    },
    //    获取物品类型
    getGoodsType() {
      this.$get("GoodsType", {}).then(
        (data) => {
          this.goodsTypeList = data;
        },
        (error) => {
          this.$message.error(error);
        }
      );
    },
    //  获取包装选项
    getPackType() {
      this.$get("PackType", {}).then(
        (data) => {
          this.packTypeList = data;
        },
        (error) => {
          this.$message.error(error);
        }
      );
    },
    //    获取增值服务类型
    getServicesType() {
      this.$get("AddedService", { type: 0 }).then(
        (data) => {
          this.servicesTypeList = data;
        },
        (error) => {
          this.$message.error(error);
        }
      );
    },
    init() {
      this.getGoodsType();
      this.getServicesType();
      this.getPackType();
    },
  },
  created() {},
  mounted() {
    this.init();
  },
};
</script>

<style scoped lang='less'>
.piece_order {
  width: 1180px;
  display: flex;
  justify-content: space-between;
  margin: 24px calc(50% - 590px) 0 calc(50% - 590px);
  /deep/ .el-form-item {
    margin-bottom: 0px;
  }
  /deep/ .el-checkbox__label {
    font-size: 18px;
    font-weight: 400;
    color: #999999;
  }
  /deep/ .el-checkbox__inner {
    width: 18px;
    height: 18px;
    position: relative;
    top: -1px;
  }
  /deep/ .el-form-item__content {
    line-height: 40px;
  }
  /deep/ .el-checkbox__inner::after {
    height: 9px;
    left: 6px;
  }
  //
  /deep/ .el-radio {
    line-height: 40px;
    height: 40px;
  }
  /deep/ .el-checkbox {
    line-height: 40px;
    height: 40px;
  }
  /deep/ .el-radio__inner {
    width: 18px;
    height: 18px;
    font-size: 18px;
    position: relative;
    top: -1px;
  }
  /deep/ .el-radio__inner::after {
    width: 6px;
    height: 6px;
  }
  /deep/ .el-radio__label {
    font-weight: 400;
    font-size: 18px;
    color: #999999;
  }
  /deep/ .el-form-item__label {
    font-size: 18px;
    color: #333;
  }
  /deep/ .el-input__inner {
    // width:260px;
    border-radius: 0;
    height: 42px;
    line-height: 42px;
    padding: 0.375rem 0.25rem;

  }
  /deep/ .el-input-group__append{
    padding: 0 5px;
  }

  &_input {
    height: 42px;
    font-size: 14px;
    line-height: 42px;
    padding: 0 16px;
    border: 1px solid #cfd7e0;
    cursor: pointer;
    &_placeholder {
      color: #a6aec1;
    }
    &_value {
      color: #606266;
    }
  }
  &_left {
    width: 580px;
    &_card {
      background: #fff;

      &_form {
        padding: 0 20px 20px 20px;
        &_checkbox {
          width: 380px;
        }
      }
      /deep/ .el-row {
        margin-top: 20px;
      }
    }
  }
  &_right {
    width: 580px;
    &_card {
      background: #fff;
      &_total {
        margin: 0 20px;
        border-top: 1px solid #e1e1e1;
        &_settlement {
          display: flex;
          justify-content: space-between;
          font-size: 24px;
          font-weight: 500;
          color: #333;
          line-height: 34px;
          padding: 16px 0;
        }
      }

      &_form {
        padding: 0 20px 20px 20px;
        &_imgList {
          display: flex;
          padding-top: 20px;
          &_item {
            position: relative;
            img {
              width: 95px;
              height: 95px;
            }
          }
          &_img {
            margin-left: 16px;
            width: 95px;
            height: 95px;
            padding: 4px;
            border: 1px solid #cfd7e0;
            border-radius: 4px;
            position: relative;
            img {
              width: 87px;
              height: 87px;
            }
            img.piece_order_right_card_form_imgList_img_icon1 {
              width: 24px;
              height: 24px;
              position: absolute;
              right: 0;
              top: 0;
              cursor: pointer;
            }
          }
        }
        &_title {
          font-size: 18px;
          color: #333333;
          font-weight: 400;
          margin-top: 16px;
        }
        &_num {
          &_unit {
            position: absolute;
            right: 46px;
            top: 0px;
            color: #333;
            font-size: 18px;
            z-index: 1;
          }
          &_unit.piece_order_right_card_form_num_lifang {
            right: 40px;
          }
        }
        &_checkbox {
          width: 380px;
        }
        /deep/ .el-input-number {
          line-height: 36px;
        }
        /deep/ &_num .el-input__inner {
          height: 36px;
          font-size: 18px;
          color: #333;

        }
        /deep/ .el-input-number__increase,
        /deep/ .el-input-number__decrease {
          width: 34px;
          height: 34px;
        }
        /deep/ .el-input-number .el-input__inner {
          padding-right: 70px;
        }
      }
      /deep/ .el-row {
        margin-top: 20px;
      }
    }
  }
  &_title.piece_order_title_btn {
    padding: 9px 20px 5px 20px;
  }
  &_title {
    padding: 16px 20px 12px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e1e1e1;
    div {
      font-size: 20px;
      line-height: 28px;
      font-weight: 500;
    }
  }
  /deep/ .piece_order_right_card_total_btn {
    display: flex;
    justify-content: flex-end;
    margin-top: 140px;
    padding-bottom: 40px;
    .el-button {
      height: 46px;
      font-size: 24px;
      font-weight: 600;
    }
  }
  &_cost_card {
    width: 1180px;
    margin: 0 calc(50% - 590px);
    background: #fff;
    margin-bottom: 80px;
    &_total {
      margin: 0 20px;
      border-top: 1px solid #e1e1e1;
      padding-left: 610px;
      &_settlement {
        display: flex;
        justify-content: space-between;
        font-size: 24px;
        font-weight: 500;
        color: #333;
        line-height: 34px;
        padding: 16px 0;
      }
      /deep/ &_btn {
        display: flex;
        justify-content: flex-end;
        padding-bottom: 40px;
        .el-button {
          height: 46px;
          font-size: 24px;
          font-weight: 600;
        }
      }
    }
    &_list {
      padding: 20px 20px 0px 20px;
      padding-left: 610px;
      &_item {
        display: flex;
        justify-content: space-between;
        font-size: 18px;
        line-height: 25px;
        padding-bottom: 16px;
        &_title {
          color: #666;
        }
        &_num {
          color: #333;
          &_coupon {
            color: #009aff;
            cursor: pointer;
          }
        }

        /deep/ .el-input-group__append {
          border: none;
          background: none;
          font-size: 18px;
          color: #333;
          padding: 0;
          padding: 0 0 0 20px;
          line-height: 24px;
        }
        /deep/ &_input .el-input__inner {
          width: 159px;
          height: 25px;
          line-height: 25px;
          font-size: 18px;
          border: 0;
          padding-right: 0;
          text-align: right;
        }
      }
    }
  }
}
.ckj1 {
  border-bottom: 1px solid #d0d0d0;
  padding: 9px 20px 5px 20px;
  line-height: 38px;
  font-size: 20px;
  /deep/ .el-input__inner {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 0px; //改成0，边框就消失了！
    width: 100%;
  }
}
.ckj1_ite1 {
  display: flex;
  line-height: 38px;
  font-size: 20px;
  padding: 10px 0px;
}
.piece_order_cost_card_list2 {
  padding: 20px 20px 0px 20px;
  /deep/ .el-input__inner {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 0px; //改成0，边框就消失了！
    width: 100%;
  }
}
.w_60 {
  width: 60%;
}
.w_40 {
  width: 40%;
}
.f_j_s {
  display: flex;
  justify-content: space-between;
}

.el-table .el-table__cell {
  padding: 5px 0 !important;
}
.tableBody {
  /deep/ .el-table__body {
  tbody {
    width: 450px;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    .el-table__row {
      width: 50%;
      height: 77px;
      border: 0;
      //   display: flex;
      //   justify-content: space-between;
    }
  }
}
}

</style>



// WEBPACK FOOTER //
// src/pages/order/pieceOrder.vue